import styled from 'styled-components'

export const SignCountSpan = styled.span`
  font-size: 12px;
  padding: 3px;
  background-color: ${props => props.theme};
  color: white;
  border-radius: 3px;
`



// WEBPACK FOOTER //
// ./src/components/List/styles/index.js